export default {"src":"/_next/static/media/abdm.77532dbd.svg","height":335,"width":363,"blurWidth":0,"blurHeight":0};